module.exports = {
	"data": {
		"allMarkdownRemark": {
			"edges": [
				{
					"node": {
						"excerpt": "\"Subtly useful\" is not something that is usually said about programming constructs. But \"defer\" is without doubt a perfect candidate for being subtly useful. Why? Defer is a way of telling a code block to execute when the function exits. If you haven...",
						"id": "/Users/lanethompson/TheRightLane/blog/src/pages/09-26-2017-swiftdefer/index.md absPath of file >>> MarkdownRemark",
						"frontmatter": {
							"title": "Using defer in Swift in 2 minutes",
							"date": "September 26, 2017",
							"path": "/swiftdefer.html"
						}
					}
				},
				{
					"node": {
						"excerpt": "I'm going to be straight with you. Most of the code you write is garbage and should never have been written! Controversial? Mean? Yes! Good, maybe it will make you change how you code. What am I doing wrong? The main culprit is over thinking. If you...",
						"id": "/Users/lanethompson/TheRightLane/blog/src/pages/09-24-2017-writeright/index.md absPath of file >>> MarkdownRemark",
						"frontmatter": {
							"title": "Writing the right code",
							"date": "September 24, 2017",
							"path": "/writeright.html"
						}
					}
				},
				{
					"node": {
						"excerpt": "One of the first things a coder notices about Swift is var and let. It seems like an odd system at first and when you add in optionals it can seem downright bizarre. Wha??? Let's start again.  What is var? Var is exactly what you would expect it is...",
						"id": "/Users/lanethompson/TheRightLane/blog/src/pages/09-22-2017-swiftletvar/index.md absPath of file >>> MarkdownRemark",
						"frontmatter": {
							"title": "Swift let and var In 2 minutes",
							"date": "September 22, 2017",
							"path": "/swiftletvar.html"
						}
					}
				},
				{
					"node": {
						"excerpt": "That's right! I'm gonna teach you all the math you need to know in 2 minutes! Feel free to send me the $30,000 you were going to pay some university! SWEET! Ok, not really, but here are the basics that you absolutely MUST know to be a working coder...",
						"id": "/Users/lanethompson/TheRightLane/blog/src/pages/09-20-2017-basicmath/index.md absPath of file >>> MarkdownRemark",
						"frontmatter": {
							"title": "Basic programming math in 2 minutes",
							"date": "September 20, 2017",
							"path": "/basicmath.html"
						}
					}
				},
				{
					"node": {
						"excerpt": "Guard is the number one thing you can do to make you code look and feel pro! Big statement? Yes, but after you start using  guard  you will find your code is better in almost every way! I don't care how my code looks! It just works. Bullshit! Pretty...",
						"id": "/Users/lanethompson/TheRightLane/blog/src/pages/09-18-2017-swiftguard/index.md absPath of file >>> MarkdownRemark",
						"frontmatter": {
							"title": "Swift guard 2 minutes",
							"date": "September 18, 2017",
							"path": "/swiftguard.html"
						}
					}
				},
				{
					"node": {
						"excerpt": "Swift has an awesome and unique  if  system. My favorite thing about it is that it doesn't need parenthesis!  Seriously! Don't use them! Don't waste time! This isn't Java! Swifty! Ugly! So what's up with  if let The best way to understand if let is...",
						"id": "/Users/lanethompson/TheRightLane/blog/src/pages/09-16-2017-swiftiflet/index.md absPath of file >>> MarkdownRemark",
						"frontmatter": {
							"title": "Swift if and if let in 2 minutes",
							"date": "September 16, 2017",
							"path": "/swiftif.html"
						}
					}
				},
				{
					"node": {
						"excerpt": "The first question I get from coders starting Swift is what's up with the for loops? What's up with Swift's for loops? Loops are one of Swifts best features. I know that sounds stupid but use Swift for a few hours and then switch to a language with C...",
						"id": "/Users/lanethompson/TheRightLane/blog/src/pages/09-14-2017-swiftfor/index.md absPath of file >>> MarkdownRemark",
						"frontmatter": {
							"title": "For loops in Swift In 2 minutes",
							"date": "September 14, 2017",
							"path": "/swiftforloop.html"
						}
					}
				},
				{
					"node": {
						"excerpt": "If you are going to get a coding job you are going to have to interview.\nAt one of those interviews,  eventually , you will get asked to do fizzbuzz. So, what is it? Fizzbuzz is a simple question There is a child's counting game called Fizzbuzz, it...",
						"id": "/Users/lanethompson/TheRightLane/blog/src/pages/09-12-2017-fizzbuzz/index.md absPath of file >>> MarkdownRemark",
						"frontmatter": {
							"title": "Fizzbuzz In 2 minutes",
							"date": "September 12, 2017",
							"path": "/fizzbuzz.html"
						}
					}
				},
				{
					"node": {
						"excerpt": "Printing out \"Hello World\" is probably the most pointless thing you could spend time on. It wasn't always that way. Back in a time when getting ANY program to run on your computer was an achievement it made sense to have a consistent test to show...",
						"id": "/Users/lanethompson/TheRightLane/blog/src/pages/09-10-2017-helloworld/index.md absPath of file >>> MarkdownRemark",
						"frontmatter": {
							"title": "Swift Hello World in 2 minutes",
							"date": "September 10, 2017",
							"path": "/helloworld.html"
						}
					}
				}
			]
		}
	},
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/index.json
// module chunks = 38